__webpack_require__.p = "https://beta.mena.safer.whs.amazon.dev/";